@if  (form_add && form_add_generated){
    
<app-formadd [config]="formConfigAdd" (submitted)="reloadTable()"></app-formadd>
}
@if  (form_update){

<app-formupdate [config]="formConfigUpdate" (submitted)="reloadTable()"></app-formupdate>
}
  <h2>{{ title }}</h2>
  <p>{{description}}</p>
<app-tablepaged  

    (update)="onUpdate($event)"
    (delete)="reloadTable()"
  [columns]="columns" 
  [path]="path" 
  [delete_button]="showDeleteButton"
  [update_button]="showUpdateButton"
  
   >
  </app-tablepaged>
